var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclosuresIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.7C0 1.20937 1.20937 0 2.7 0H15.3C16.7918 0 18 1.20937 18 2.7V15.3C18 16.7918 16.7918 18 15.3 18H2.7C1.20937 18 0 16.7918 0 15.3V2.7ZM2.7 1.8C2.20274 1.8 1.8 2.20274 1.8 2.7V15.3C1.8 15.7973 2.20274 16.2 2.7 16.2H15.3C15.7973 16.2 16.2 15.7973 16.2 15.3V2.7C16.2 2.20274 15.7973 1.8 15.3 1.8H2.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0001 10.8C8.50284 10.8 8.1001 10.3973 8.1001 9.9V5.4C8.1001 4.90274 8.50284 4.5 9.0001 4.5C9.49736 4.5 9.9001 4.90274 9.9001 5.4V9.9C9.9001 10.3973 9.49736 10.8 9.0001 10.8Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0001 13.5C8.50284 13.5 8.1001 13.0973 8.1001 12.6C8.1001 12.1028 8.50284 11.7 9.0001 11.7C9.49736 11.7 9.9001 12.1028 9.9001 12.6C9.9001 13.0973 9.49736 13.5 9.0001 13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclosuresIcon);
export default __webpack_public_path__ + "static/media/Disclosures_Icon.fbc438f1.svg";
export { ForwardRef as ReactComponent };